import React from 'react';
import {useSelector} from 'react-redux';
import classNames from 'classnames';

import getFilterCount from './Filters/getFilterCount';
import getUserPermissions from '../getUserPermissions';

import StyledToolbar, {StyledSelect} from './StyledToolbar';
import DefineCustomAttribute from './DefineCustomAttribute';
import CustomizeTableModal from '../CustomizeTableModal';
import ContactsFilter from './Filters/ContactsFilter';
import GenerateMessage from './GenerateMessage';
import RemoveContact from './RemoveContact';
import ToolbarSearch from './ToolbarSearch';
import SelectedUsers from './SelectedUser';
import ManageAccess from './ManageAccess';
import AddContact from './AddContact';
import MessageLog from './MessageLog';
import SelectAll from './SelectAll/';
import ExportTable from './ExportTable';
import AccessLog from './AccessLog';
import Tag from './Tag';
import StyledControls from './StyledControls';
import StyledSelection from './StyledSelection';

const Toolbar = () => {
	const hasSelected = useSelector(({contacts}) => contacts?.selected?.length > 0);
	const hasFilters = useSelector(({contacts}) => {
		const filters = contacts?.filters?.filterTypes;
		if (!filters) return false;
		return getFilterCount(filters) > 0;
	});

	const {
		addContactPermission,
		accessLogPermission,
		messageLogPermission,
		customizeTablePermission,
		exportTablePermission,
		manageAccessPermission,
		defineAttributesPermission,
		tagsPermission,
		generateMessagePermission,
		removeContactPermission
	} = useSelector((state) =>
		getUserPermissions({
			userPreferences: state.userPreferences,
			entities: state.project?.orgStructure,
			userList: state.project?.users
		})
	);

	const renderUnselected = () => (
		<>
			{addContactPermission && <AddContact />}
			{accessLogPermission && <AccessLog />}
			{messageLogPermission && <MessageLog />}
			{customizeTablePermission && <CustomizeTableModal />}
			{exportTablePermission && <ExportTable />}
		</>
	);

	const renderSelected = () => (
		<>
			{manageAccessPermission && <ManageAccess />}
			{defineAttributesPermission && <DefineCustomAttribute />}
			{tagsPermission && <Tag />}
			{generateMessagePermission && <GenerateMessage />}
			{removeContactPermission && <RemoveContact />}
		</>
	);

	return (
		<StyledToolbar className={classNames({selected: hasSelected, filters: hasFilters})}>
			<ContactsFilter />
			<ToolbarSearch />
			{hasSelected && (
				<StyledSelection className="selection">
					<SelectAll />
					<SelectedUsers />
				</StyledSelection>
			)}
			<StyledControls className="controls">{hasSelected ? renderSelected() : renderUnselected()}</StyledControls>
		</StyledToolbar>
	);
};

export default Toolbar;
